module.exports = __webpack_public_path__ + "static/media/4.fbd4df70.jpg";